module.exports = __webpack_public_path__ + "static/media/pastille.5ddf8bf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pastille.svg
// module id = 461
// module chunks = 0